import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TenantDriverDto } from '../../drivers/dtos/tenant-driver.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { CustomerStatusEnum } from '../enums/customer-status.enum';
import { CustomerTypeEnum } from '../enums/customer-type.enum';

/**
 * Customer DTO for records
 */
@CaslSubject(AppSubjectEnum.CUSTOMER)
export class CustomerRecordDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  type!: CustomerTypeEnum;
  status!: CustomerStatusEnum;
  contactShortName?: string | null;
  notes?: string | null;
  contact!: TenantContactDto;
  driver?: TenantDriverDto | null;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
